import { db } from '../config/firebase';
import { collection, getDocs, deleteDoc, doc, updateDoc } from 'firebase/firestore';

export const resetUserProgress = async (userId) => {
  try {
    // Delete all course progress
    const coursesRef = collection(db, 'user_progress', userId, 'courses');
    const coursesSnap = await getDocs(coursesRef);
    let deleted = 0;
    for (const docSnap of coursesSnap.docs) {
      await deleteDoc(docSnap.ref);
      deleted++;
    }

    // Reset intake completion status so the intake form shows again
    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, {
      hasCompletedIntake: false,
      commitmentLevel: null,
      intakeCompletedAt: null
    });

    return { success: true, deleted };
  } catch (error) {
    console.error('Error resetting user progress:', error);
    return { success: false, error: error.message };
  }
};
